
<!-- 
  Article inner content
-->

<template>
  
      <header class="fullscreen-element no-pad centered-text" id="top">

        <div class="container masthead-container masthead-container-home" v-if="page=='home'">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-10 col-md-offset-1 col-lg-10 col-lg-offset-1 text-left">
              <div id="home-masthead" class="masthead-inner">

                <div class="masthead-logo desktop">
                  <img :src="'static/img/common/logo.png'" />
                </div>

                <div class="masthead-image masthead-image-1">
                  <image-loader 
                    class="masthead-desktop"
                    :imgSrc="'home/'+home.lockup.lockup_1"
                    >
                  </image-loader>
                </div>
                <div class="masthead-image masthead-image-2">
                  <image-loader 
                    class="masthead-desktop"
                    :imgSrc="'home/'+home.lockup.lockup_2"
                    >
                  </image-loader>
                </div>
                <div class="masthead-image masthead-image-3">
                  <image-loader 
                    class="masthead-desktop"
                    :imgSrc="'home/'+home.lockup.lockup_3"
                    >
                  </image-loader>
                </div>
                <div class="masthead-image masthead-text">
                  <image-loader 
                    class="masthead-desktop"
                    :imgSrc="'home/'+home.lockup.text_img"
                    >
                  </image-loader>
                </div>
              </div>
            </div>
          </div>
        </div>

          <div class="container masthead-container masthead-container-food" v-if="page=='food'">
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-10 col-md-offset-1 col-lg-10 col-lg-offset-1 text-left">
              <div class="masthead-inner">
                <div class="masthead-image masthead-image-1">
                  <image-loader 
                    class="masthead-desktop"
                    :imgSrc="'food/'+food.lockup.lockup_1"
                    >
                  </image-loader>
                </div>
                <div class="masthead-image masthead-image-2">
                  <image-loader 
                    class="masthead-desktop"
                    :imgSrc="'food/'+food.lockup.lockup_2"
                    >
                  </image-loader>
                </div>
                <div class="masthead-image masthead-image-3">
                  <image-loader 
                    class="masthead-desktop"
                    :imgSrc="'food/'+food.lockup.lockup_3"
                    >
                  </image-loader>
                </div>
                <div class="masthead-image masthead-text">
                  <image-loader 
                    class="masthead-desktop"
                    :imgSrc="'food/'+food.lockup.text_img"
                    >
                  </image-loader>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container masthead-container masthead-container-takeaway" v-if="page=='takeaway'">
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-10 col-md-offset-1 col-lg-10 col-lg-offset-1 text-left">
              <div class="masthead-inner">
                <div class="masthead-image masthead-image-1">
                  <image-loader 
                    class="masthead-desktop"
                    :imgSrc="'takeaway/'+takeaway.lockup.lockup_1"
                    >
                  </image-loader>
                </div>
                <div class="masthead-image masthead-image-2">
                  <image-loader 
                    class="masthead-desktop"
                    :imgSrc="'takeaway/'+takeaway.lockup.lockup_2"
                    >
                  </image-loader>
                </div>
                <div class="masthead-image masthead-image-3">
                  <image-loader 
                    class="masthead-desktop"
                    :imgSrc="'takeaway/'+takeaway.lockup.lockup_3"
                    >
                  </image-loader>
                </div>
                <div class="masthead-image masthead-text">
                  <image-loader 
                    class="masthead-desktop"
                    :imgSrc="'takeaway/'+takeaway.lockup.text_img"
                    >
                  </image-loader>
                </div>
              </div>
            </div>
          </div>
        </div>

          <div class="container masthead-container masthead-container-projects" v-if="page=='projects'">
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-10 col-md-offset-1 col-lg-10 col-lg-offset-1 text-left">
              <div class="masthead-inner">
                <div class="masthead-image masthead-image-1">
                  <image-loader 
                    class="masthead-desktop"
                    :imgSrc="'projects/'+projects.lockup.lockup_1"
                    >
                  </image-loader>
                </div>
                <div class="masthead-image masthead-image-2">
                  <image-loader 
                    class="masthead-desktop"
                    :imgSrc="'projects/'+projects.lockup.lockup_2"
                    >
                  </image-loader>
                </div>
                <div class="masthead-image masthead-image-3">
                  <image-loader 
                    class="masthead-desktop"
                    :imgSrc="'projects/'+projects.lockup.lockup_3"
                    >
                  </image-loader>
                </div>
                <div class="masthead-image masthead-text">
                  <image-loader 
                    class="masthead-desktop"
                    :imgSrc="'projects/'+projects.lockup.text_img"
                    >
                  </image-loader>
                </div>
              </div>
            </div>
          </div>
        </div>

      </header>
</template>

<style>

header {
  padding: 0;
  position: relative;
}
.masthead-container {
  position: relative;
  overflow: hidden;
  margin-bottom: 15px;
}
.masthead-image {
  position: absolute;
  height:auto;
}
.masthead-inner {
  height: 100%;
  width:100%;
  position: relative;
}
.masthead-logo {
  position: relative;
  top: auto;
  left:20%;
  width: 60%;
}

.masthead-container-home {
  height: 300px;
}
.masthead-container-food {
  height: 320px;
}
.masthead-container-projects {
  height: 300px;
}
.masthead-container-takeaway {
  height: 240px;
}

.masthead-container-home .masthead-text {
  width: 86%;
  top:25%;
  left: 5%;
}
.masthead-container-home .masthead-image-1 {
  left: auto;
  right: 5%;
  width: 27%;
  top: 0%; 
  bottom: auto;
}
.masthead-container-home .masthead-image-2 {
  right: auto;
  left:28%;
  width: 50%;
  top: auto;
  bottom:0;
}
.masthead-container-home .masthead-image-3 {
  right: auto;
  left: 14%;
  width: 18%;
  bottom: 10%;
}

.masthead-container-food .masthead-text {
  width: 43%;
  top:18%;
  left: 5%;
}
.masthead-container-food .masthead-image-1 {
  left: 10%;
  right: auto;
  width: 25%;
  top: auto; 
  bottom: 0;
  z-index: 1;
}
.masthead-container-food .masthead-image-2 {
  right: auto;
  left:28%;
  width: 60%;
  top: auto;
  bottom:8%;
  z-index: 0;
}
.masthead-container-food .masthead-image-3 {
  right: 5%;
  left:auto;
  width: 52%;
  bottom: auto;
  top: 0;
}

.masthead-container-projects .masthead-text {
  width: 70%;
  top:5%;
  left: 7%;
}
.masthead-container-projects .masthead-image-1 {
  left: auto;
  right: 10%;
  width: 25%;
  top: auto; 
  bottom: 0;
}
.masthead-container-projects .masthead-image-2 {
  right: auto;
  left:5%;
  width: 52%;
  top: auto;
  bottom:21%;
}
.masthead-container-projects .masthead-image-3 {
  right: 5%;
  left:auto;
  width: 34%;
  bottom: auto;
  top: 9%;
}

.masthead-container-takeaway .masthead-text {
  width: 56%;
  top:23%;
  bottom: auto;
  left: 0%;
  right: auto;
}
.masthead-container-takeaway .masthead-image-1 {
  right: 0%;
  left:auto;
  width: 43%;
  top: 0; 
  bottom: auto;
  z-index: 1;
}
.masthead-container-takeaway .masthead-image-2 {
  right: auto;
  left:11%;
  width: 36%;
  top: auto;
  bottom:21%;
  z-index: 0;
}
.masthead-container-takeaway .masthead-image-3 {
  left: 21%;
  right: auto;
  width: 14%;
  top: 0;
  bottom: auto;
}
/*.masthead-desktop {
  display: none;
}
.masthead-container {
  height: 220px;
  margin-top: 20px;
}
.masthead-inner {
  height: 100%;
}

.masthead-container h1 {
  position: absolute;
  top: 33%!important;
  font-size: 22px!important;
  line-height: 23px!important;
}
.masthead-image-1 {
    left: 27%;
    width: 21%;
    right: auto;
    top: 55%;
  }
.masthead-image-1 img {
  padding-left: 0;
}

.masthead-image-2 {
  right: 0%;
  width: 50%;
  bottom: auto;
  top:10%;
}
.masthead-image-2 img {
  padding-right: 15px;
}
.masthead-image-3 {
  right: 13%;
  width: 15%;
  top: 55%; 
}*/


@media (min-width: 576px) {
  .masthead-container {
    position: relative;
    overflow: hidden;
    margin-bottom: 30px;
  }
  .masthead-container-home {
    height: 450px;
  }
  .masthead-container-food {
    height: 480px;
  }
  .masthead-container-projects {
    height: 450px;
  }
  .masthead-container-takeaway {
    height: 360px;
  }

/*.masthead-container-home .masthead-text {
  width: 86%;
  top:25%;
  left: 5%;
}
.masthead-container-home .masthead-image-1 {
  left: auto;
  right: 5%;
  width: 27%;
  top: 0%; 
  bottom: auto;
}
.masthead-container-home .masthead-image-2 {
  right: auto;
  left:28%;
  width: 50%;
  top: auto;
  bottom:0;
}
.masthead-container-home .masthead-image-3 {
  right: auto;
  left: 14%;
  width: 18%;
  bottom: 10%;
}*/
/*  .masthead-container {
    height: 320px;
  }
  .masthead-container h1 {
    top: 26%!important;
    font-size: 33px!important;
    line-height: 36px!important;
  }
  .masthead-image-1 {
    width: 21%;
    top:45%;
    left:27%;
  }
  .masthead-image-2 {
    width: 50%;
    top:0%;
  }
  .masthead-image-3 {
    right: 13%;
    width: 15%;
    top: 50%; 
  }*/
}
@media (min-width: 768px) {
  .masthead-logo {
    position: absolute;
    top: 10%;
    left:5%;
    width: 35%;
  }
  .masthead-container {
    position: relative;
    top:50%;
    -webkit-transform: translateY(-50%);
    color: #000;
    margin-bottom: 0;
  }
  .masthead-container-home {
    height: 420px;
  }
  .masthead-container-food {
    height: 420px;
  }
  .masthead-container-projects {
    height: 480px;
  }
  .masthead-container-takeaway {
    height: 360px;
  }
  
/*  .masthead-container-home h1 {
    top: 38%!important;
    font-size: 40px!important;
    line-height: auto;
    position: absolute;
    margin: 0;
  }*/
  .masthead-container-home .masthead-text {
    width: 60%;
    top:39%;
    bottom: auto;
    left: 0;
    right: auto;
  }
  .masthead-container-home .masthead-image-1 {
    left: 30%;
    width: 18%;
    top: 50%; 
    bottom: auto;
    right: auto;
  }
  .masthead-container-home .masthead-image-2 {
    right: 0;
    left:auto;
    width: 50%;
    top:0;
    bottom: auto;
  }
  .masthead-container-home .masthead-image-3 {
    right: 9%;
    left: auto;
    width: 18%;
    top: 51%;
    bottom: auto;
  }

  /*.masthead-container-food h1 {
    top: 20%!important;
    font-size: 52px!important;
    line-height: auto;
    position: absolute;
    margin: 0;
  }*/
  .masthead-container-food .masthead-text {
    width: 29%;
    top:20%;
    left: 0;
    bottom: auto;
  }
  .masthead-container-food .masthead-image-1 {
    left: 7%;
    right: auto;
    top: auto;
    width: 21%;
    bottom: 0; 
  }
  .masthead-container-food .masthead-image-2 {
    right: 5%;
    width: 60%;
    left:auto;
    bottom: auto;
    top:0;
  }
  .masthead-container-food .masthead-image-3 {
    right: 0;
    width: 25%;
    top: 56%;
    left:auto;
    bottom: auto;
  }

/*  .masthead-container-projects h1 {
    top: 10%!important;
    font-size: 53px!important;
    line-height: 55px;
    position: absolute;
    margin: 0;
  }*/
  .masthead-container-projects .masthead-text {
    width: 55%;
    top: 15%;
    bottom: auto;
    left:0;
  }
  .masthead-container-projects .masthead-image-1 {
    left: 17%;
    width: 20%;
    top: 51%; 
    right:auto;
    bottom: auto;
  }
  .masthead-container-projects .masthead-image-2 {
    right: 0;
    width: 56%;
    top:27%;
    left:auto;
    bottom: auto;
  }
  .masthead-container-projects .masthead-image-3 {
    right: 11%;
    width: 20%;
    top: 0%;
    left:auto;
    bottom: auto;
  }

  .masthead-container-takeaway .masthead-text {
  width: 56%;
  top:23%;
  bottom: auto;
  left: 0%;
  right: auto;
}
.masthead-container-takeaway .masthead-image-1 {
  right: 0%;
  left:auto;
  width: 33%;
  top: 0; 
  bottom: auto;
  z-index: 1;
}
.masthead-container-takeaway .masthead-image-2 {
  right: auto;
  left:21%;
  width: 36%;
  top: auto;
  bottom:11%;
  z-index: 0;
}
.masthead-container-takeaway .masthead-image-3 {
  left: 20%;
  right: auto;
  width: 16%;
  top: 0;
  bottom: auto;
}

  .masthead-mobile {
    display: none;
  }
  .masthead-desktop {
    display: block;
  }
}
@media (min-width: 992px) {
.masthead-container-takeaway {
    height: 390px;
  }
/*  .masthead-container {
    height: 520px;
  }
  .masthead-container h1 {
    top: 32%!important;
    font-size: 60px!important;
    line-height: 64px!important;
  }
  .masthead-image-1 {
    width: 19.5%;
    top:auto;
    bottom:0%;
    left:28.7%;
  }
  .masthead-image-2 {
    width: 50%;
    top:0%;
  }
  .masthead-image-3 {
    right: 12%;
    width: 15%;
    top: 50%; 
  }*/
}
@media (min-width: 1200px) {
  
  .masthead-container-home {
    height: 525px;
  }
/*  .masthead-container-home .masthead-text {
    width: 57%;
    top:42%;
  }
  .masthead-container-home .masthead-image-1 {
    left: 30%;
    width: 18%;
    top: 53%; 
  }*/
  .masthead-container-food {
    height: 500px;
  }
  .masthead-container-projects {
    height: 540px;
  }
  .masthead-container-takeaway {
    height: 480px;
  }
  .masthead-container-projects .masthead-image-1 {
    left: 17%;
    width: 19%;
    top: 54%; 
  }
}

</style>

<script>
// import Vue from 'vue'
import {food, projects, home, takeaway} from '../../content.json'
import ImageLoader from '../components/ImageLoader'
import Vue from 'vue'
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
  observer: true,
  throttleWait: 3000,
  // optional
  observerOptions: {
    rootMargin: '0px',
    threshold: 0.1
  },
  lazyComponent: true
})
export default {
  props: ['page'],
  data: function () {
    return {
      home,
      food,
      takeaway,
      projects,
      paddingTop: 0,
      mastheight: 0
    }
  },
  methods: {
    padMast: function () {
      let ch = this.$el.clientHeight
      this.paddingTop = (ch / 2)
    }
  },
  created () {
    window.addEventListener('scroll', this.scrollMast)
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollMast)
  },
  mounted: function () {
    this.mastheight = '100%'
    this.padMast()
  },
  computed: {
    // a computed getter
  },
  components: {
    ImageLoader
  }
}
</script>



// WEBPACK FOOTER //
// MastHead.vue?191ab34c